import { AdjuntosCellRenderer } from "../../../../../../shared/components/CustomCells/AdjuntosCellRenderer";
import { BooleanCellRenderer } from "../../../../../../shared/components/CustomCells/BooleanCellRenderer";
import { CentroObraCellRenderer } from "../../../../../../shared/components/CustomCells/CentroObraCellRenderer";
import { EstadoParteCellRenderer } from "../../../../../../shared/components/CustomCells/EstadoParteCellRenderer";
import { MultiSociedadCellRenderer } from "../../../../../../shared/components/CustomCells/MultiSociedadCellRenderer";
import { ColumnsFactory } from "../../../../../../shared/components/Grid/functions";

const etsdoValue = (params) =>{
  switch (params.value) {
    case 1:
      return "Sin Validar"
      case 2:
        return "Área";
        case 3:
         return "Fiscal";
          case 4:
            return "Facturación";
    default: return "Sin Validar"
  }
}

const multiSociedadvalue = (params) =>{
  if(params.data.multiplesSociedades)
  {
    return "multisociedad"
  }else{
    return params.value
  }
}

export const getColumnDefs = (columnsUser) => {
  return [
    ColumnsFactory.DateColumn("Fecha", "fecha", {hide:(columnsUser?!columnsUser['fecha']:false),headerCheckboxSelection: true,checkboxSelection:true,headerCheckboxSelectionFilteredOnly: true, pinned: "left"}),
    ColumnsFactory.NumericColumn("Validación", "estado", {hide:(columnsUser?!columnsUser['estado']:false),cellRendererFramework: EstadoParteCellRenderer, headerClass: 'validacionHeader', 
    cellStyle:{ "text-align": "center", "line-height": "0px"}, valueFormatter: etsdoValue, floatingFilterComponent: 'EstadoFilter',
    pinned: "left",
    floatingFilterComponentParams: {
      suppressFilterButton: true
    }}),
    ColumnsFactory.BooleanColumn("Facturado", "facturado", {hide:(columnsUser?!columnsUser['facturado']:false),cellRendererFramework:BooleanCellRenderer,pinned: "left"}),
    ColumnsFactory.BooleanColumn("Desplazado", "desplazado", {hide:(columnsUser?!columnsUser['desplazado']:false),cellRendererFramework: BooleanCellRenderer,pinned: "left"}),
    ColumnsFactory.DateColumn("Fecha Facturado", "fechaFacturacion", {hide:(columnsUser?!columnsUser['fechaFacturacion']:false)}),
    ColumnsFactory.TextColumn("Dni", "dni", {pinned: "left",hide:(columnsUser?!columnsUser['dni']:false)}),
    ColumnsFactory.TextColumn("Nombre", "nombre",{pinned: "left",hide:(columnsUser?!columnsUser['nombre']:false)}),
    ColumnsFactory.TextColumn("Sg/Dn", "direccionNegocio",{hide:(columnsUser?!columnsUser['direccionNegocio']:false)}),
    ColumnsFactory.TextColumn("Area", "area",{hide:(columnsUser?!columnsUser['area']:false)}),
    ColumnsFactory.TextColumn("Sociedad", "sociedad", {hide:(columnsUser?!columnsUser['sociedad']:false),cellRendererFramework: MultiSociedadCellRenderer, cellStyle:{ "line-height": "0px"}, valueFormatter: multiSociedadvalue}),
    ColumnsFactory.TextColumn("País", "pais", {hide:(columnsUser?!columnsUser['pais']:false)}),
    ColumnsFactory.TextColumn("Proyecto", "proyecto", {hide:(columnsUser?!columnsUser['proyecto']:false)}),
    ColumnsFactory.TextColumn("Centro/Obra", "codCentroObra", {hide:(columnsUser?!columnsUser['codCentroObra']:false),cellRendererFramework: CentroObraCellRenderer}),
    ColumnsFactory.TextColumn("Obra", "obra", {hide:true}),
    ColumnsFactory.TextColumn("Funcion", "funcion", {hide:(columnsUser?!columnsUser['funcion']:false)}),
    ColumnsFactory.TextColumn("SubFuncion", "subFuncion", {hide:(columnsUser?!columnsUser['subFuncion']:false)}),
    ColumnsFactory.DecimalColumn("Horas Diarias", "nHoras",{editable:false, hide:(columnsUser?!columnsUser['nHoras']:false)}),
    ColumnsFactory.BooleanColumn("Adjuntos", "tieneAdjuntos", {hide:(columnsUser?!columnsUser['tieneAdjuntos']:false),cellRendererFramework: AdjuntosCellRenderer}),
    ColumnsFactory.TextColumn("Observaciones", "observaciones", {hide:(columnsUser?!columnsUser['observaciones']:false)})
  ];
};
